'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _OrsUtil = require('./OrsUtil');

var _OrsUtil2 = _interopRequireDefault(_OrsUtil);

var _OrsPoisSchema = require('./schemas/OrsPoisSchema');

var _OrsPoisSchema2 = _interopRequireDefault(_OrsPoisSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var orsUtil = new _OrsUtil2.default();

var OrsPois = function () {
  function OrsPois(args) {
    _classCallCheck(this, OrsPois);

    this.args = {};
    if ('api_key' in args) {
      this.args.api_key = args.api_key;
    } else {
      console.log('Please add your openrouteservice api_key...');
    }
  }

  _createClass(OrsPois, [{
    key: 'clear',
    value: function clear() {
      for (var variable in this.args) {
        if (variable !== 'api_key') delete this.args[variable];
      }
    }
  }, {
    key: 'generatePayload',
    value: function generatePayload(args) {
      var payload = {};

      for (var key in args) {
        if (key === 'host' || key === 'api_version' || key === 'mime_type' || key === 'api_key') {
          continue;
        } else {
          payload[key] = args[key];
        }
      }
      return payload;
    }
  }, {
    key: 'poisPromise',
    value: function poisPromise(schema) {
      var that = this;
      return new _bluebird2.default(function (resolve, reject) {
        _joi2.default.validate(that.args, schema, function (err, value) {
          if (err !== null) reject(new Error(err));

          var timeout = 5000;
          that.args = value;

          var url = that.args.host + '?api_key=' + value.api_key;

          var payload = that.generatePayload(that.args);

          _superagent2.default.post(url).send(payload).accept(that.args.mime_type).timeout(timeout).end(function (err, res) {
            //console.log(res.body, res.headers, res.status)
            if (err || !res.ok) {
              console.log(err);
              //reject(ghUtil.extractError(res, url));
              reject(new Error(err));
            } else if (res) {
              resolve(res.body);
            }
          });
        });
      });
    }
  }, {
    key: 'pois',
    value: function pois(reqArgs) {
      orsUtil.copyProperties(reqArgs, this.args);

      return this.poisPromise(_OrsPoisSchema2.default);
    }
  }]);

  return OrsPois;
}();

exports.default = OrsPois;